import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import ReactJson from 'react-json-view'
import bom001 from "../../json/bom/bom-001.json";
import v1_Bom_001 from "../../assets/v1.Bom-001.png";


export default function BomsGet() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Boms GET</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Overview</p>

            <p style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                In Enlil, a revision of a part may participate in bill of materials (BOM). Membership in a BOM is hierarchical with all parts (except the root part) having a parent and zero or more children.
            </p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>To download an existing BOM, the boms GET API (v1.Bom-001) will return the parent and the parent's immediate BOM membership starting with the provided part revision USID.</li>
            </ul>
            <br/>
            <span style={{textDecoration: "underline"}}><b>v1.Bom-001</b></span>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                v1.Bom-001 is an IDOC designed to return the part revision record for the parent and the parent's subordinate part revisions (0:M) along with future revisions (0:M) and alternate parts (0:M).
            </p>
            <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                <ReactJson src={bom001} collapseStringsAfterLength={75} collapsed={3}/>
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Parameters</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>Header Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-AccessToken (Required String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-AccessToken is obtained during the authentication process and expires after 90 days.</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-RefreshToken (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-RefreshToken is obtained during the authentication process and never expires. This token is provided is the caller wants a refreshed X-Enlil-AccessToken</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>idoc-response (Optional String: Default v1.Bom-001)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The name of the IDOC being requested.</li>
                </li>
                <li style={{marginTop: "20px"}}>Basic Query Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>USID (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The primary key of the bom entity</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>DocumentRevisionID (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The USID of the part revision</li>
                </li>

            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Examples</p>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                Enlil provides one IDOC format to retrieve BOM related data using the boms GET API. For example, if the user executes this request:<br/><br/>

                <span style={{fontFamily: "Courier New", fontSize: "14px",}}>curl -G -d "DocumentRevisionUSID=88888888-4444-4444-4444-121212121212" -H "idoc-response: v1.Bom-001" -H "X-Enlil-AccessToken: &#60;token&#62;" http://integrate.enlil.io/t3/v1/boms</span>
                <br/><br/>
                The response will resemble:<br/><br/>

                <p style={{fontFamily: "Courier New", fontSize: "12px"}}>
                    <ReactJson src={bom001} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>IDOCs</p>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px", lineHeight: "1.2"}}>
                <span style={{textDecoration: "underline"}}><b>v1.Bom-001</b></span><br/><br/>
                <span style={{lineHeight: "1.5em"}}>v1.Bom-001 is an IDOC designed to return information about the bom record. v1.Bom-001 is limited to a maximum of 1 record per request. The scope of v1.Bom-001 is highlighted below.</span>

                <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                    <img src={v1_Bom_001} alt={"v1.Bom-001"}/>
                </p>


                <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                    <ReactJson src={bom001} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
            </p>
        </div>
    )
}